/* CSS Document */

var jLoadTimer = setInterval(function(){
	if(typeof jQuery != "undefined"){

		clearInterval(jLoadTimer);

		jQuery(function($){
      mvisAnime();
			scroll_to_add($);
      floatingBanner();
		});
	}
}, 100);

function mvisAnime(){
  var wdw = $(window);
  /*var product = $("#mvis .product img, #s01 > .constBox > .inner, #s02 .lead p, #s02 > .constBox > .inner");*/
  var product = $("#mvis .product img, #s02 .lead p");
  
  wdw.scroll(function(){
    var st = wdw.scrollTop();
    var move = 0;
    product.each(function(n){
      var self = $(this);
      if(n > 0){
        var parentPos = self.parent().offset().top-wdw.height();
        if(st > parentPos) {
          move = (st-parentPos)*0.18;
          self.css({transform: "translateY(-"+move+"px)"});
        }
      }else{
        move = st*0.3;
        self.css({transform: "translateY(-"+move+"px)"});
      }
    });
    
  });
  
  wdw.scroll();
}

function floatingBanner(){
  var wdw = $(window);
  var floating = $(".floating");
  var trigger = $("#s02 > .vis");
   wdw.scroll(function(){
    var st = wdw.scrollTop();
    if(st > trigger.offset().top){
      if(!floating.hasClass("on")){
        floating.addClass("on");
      }
    }else{
      if(floating.hasClass("on")){
        floating.removeClass("on");
      }
    }
    
  });
}


function scroll_to_add($){
	var addOnPosition = 0.75;//開始位置設定window高さの75%のところにきたらclass:onが追加
	var wdw = $(window);
	var anims = $(".anime");

	anims.each(function(){
		var target = $(this);
		if(target.data("children")){
			var children = target.data("children").split(",");
			var arr = [];
			for(var i=0;i<children.length;i++){
				$(children[i], target).each(function(){
					arr.push($(this));
					});//each
				}//for
			target.data("children", arr);
			}//if
		});//each


	function addOn(sct){
		anims.each(function(){
			var target = $(this);

			if(target.offset().top < sct){
				if(target.hasClass("on")) return;

				//on追加
				if(target.data("children")){
					var delay = (target.data("delay")) ? target.data("delay") : 0;
					var arr = target.data("children");
					for(var s in arr){
						setTimeout(setClassOn(arr[s]), delay*s);
						}
					//親にもクラス追加
					target.addClass("on");
					}else
				if(target.data("delay")){
					setTimeout(setClassOn(target), target.data("delay"));
					}else{
						target.addClass("on");
						}
				}else{
					if(!target.hasClass("on")) return;

					//on削除
					/*if(target.data("children")){
						var arr = target.data("children");
						for(var s in arr){
							arr[s].removeClass("on");
							}
						}*/

					//data-children有無にかかわらずクラスanimeにon削除
					//target.removeClass("on");
					}//if
			});//each
		}//addOn

	function setClassOn(target){
		return function(){
			target.addClass("on");
			};
		}

	wdw.scroll(function(){
		var sct = wdw.scrollTop()+wdw.height()*addOnPosition;
		addOn(sct);
		});
	wdw.scroll();
}